import _ from 'lodash';

import { getPrimaryUserRole } from 'constants/userRoles';

export const USER_MANAGEMENT_PAGE = 'settings/user-management';
export const INTERGRATION_USER_MANAGEMENT_PAGE = 'integration-settings/user-management';

const routePermissions = {
  [USER_MANAGEMENT_PAGE]: 'workspaceManagement.userManagement',
  [INTERGRATION_USER_MANAGEMENT_PAGE]: 'workspaceManagement.userManagement'
}

export default class userRoleService {

  static initialise(workspace, callback) {
    this.userRole = getPrimaryUserRole(workspace.userRoles) || {};

    if(callback) {
      callback();
    }
  }

  static canCreateStoryboard() {
    return _.get(this.userRole, 'workspaceManagement.createStoryBoards', false);
  }

  static canManageUsers() {
    return _.get(this.userRole, 'workspaceManagement.userManagement', false);
  }

  static requirePermission(path, profile) {
    var userRole = getPrimaryUserRole(profile && profile.userRoles) || {};
    var access = routePermissions[path];

    if (!access) {
      return true
    }

    return _.get(userRole, access, false)
  }
}